// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionLoading_wrapper__ginhT"};